import { useEffect } from "react";

const LazyIntercom = () => {
  useEffect(() => {
    const loadIntercomScript = () => {
      // Customize your Intercom script here
      window.intercomSettings = {
        api_base: "https://api-iam.intercom.io",
        app_id: "uy7c1bae", // Replace with your Intercom App ID
        custom_launcher_selector: '#contactus',
      };

      // Intercom script
      (function () {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
          ic("reattach_activator");
          ic("update", w.intercomSettings);
        } else {
          var d = document;
          var i = function () {
            i.c(arguments);
          };
          i.q = [];
          i.c = function (args) {
            i.q.push(args);
          };
          w.Intercom = i;
          var l = function () {
            var s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/uy7c1bae";
            var x = d.getElementsByTagName("script")[0];
            x.parentNode.insertBefore(s, x);
          };
          if (document.readyState === "complete") {
            l();
          } else if (w.attachEvent) {
            w.attachEvent("onload", l);
          } else {
            w.addEventListener("load", l, false);
          }
        }
      })();
    };

    // Delay the execution of the loadIntercomScript by 60 seconds after the page load
    const delayScriptLoad = () => {
      setTimeout(() => {
        loadIntercomScript();
      }, 90000); // 90 seconds
    };

    if (document.readyState === "complete") {
      delayScriptLoad();
    } else {
      window.addEventListener("load", delayScriptLoad);
    }
  }, []);

  return null; // Return null as this component does not render anything
};

export default LazyIntercom;
